import { render, staticRenderFns } from "./Setari_list.vue?vue&type=template&id=62b776f1&scoped=true&"
import script from "./Setari_list.vue?vue&type=script&lang=js&"
export * from "./Setari_list.vue?vue&type=script&lang=js&"
import style0 from "./Setari_list.vue?vue&type=style&index=0&id=62b776f1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b776f1",
  null
  
)

export default component.exports